import { useRouter } from 'next/router';

interface UseRouterQueryInterface {
  addUrlQueryParam: (param: string, value: string) => void;
  removeUrlQueryParam: (param: string) => void;
  getUrlQueryParam: (param: string) => string | undefined;
}

const useRouterQuery = (): UseRouterQueryInterface => {
  const router = useRouter();

  const removeUrlQueryParam = (param: string) => {
    const updatedQuery = { ...router.query };

    if (updatedQuery[param]) {
      delete updatedQuery[param];
    }

    router.replace({ query: updatedQuery }, undefined, { shallow: true });
  };

  const addUrlQueryParam = (param: string, value: string) => {
    const currentQuery = { ...router.query };

    // Add the new value to the query
    currentQuery[param] = value.trim();

    router.replace({ query: currentQuery }, undefined, { shallow: true });
  };

  const getUrlQueryParam = (param: string): string | undefined => {
    return router.query[param] as string | undefined;
  };

  return { addUrlQueryParam, removeUrlQueryParam, getUrlQueryParam };
};

export { useRouterQuery };
